import { DataType } from "../../../evaluators/DataType";
import { TypeMember } from "../../../evaluators/TypeMember";

export class DataTypes
{
  static Number  = new DataType( "Number" );

  static Vector2 = new DataType( "Vector2" ).setMembers( 
    [ 
      TypeMember.create( "x", DataTypes.Number ),
      TypeMember.create( "y", DataTypes.Number )
    ] 
  );
  
  static Vector3 = new DataType( "Vector3" ).setMembers( 
    [ 
      TypeMember.create( "x", DataTypes.Number ),
      TypeMember.create( "y", DataTypes.Number ),
      TypeMember.create( "z", DataTypes.Number )
    ] 
  );

  static Vector4 = new DataType( "Vector4" ).setMembers( 
    [ 
      TypeMember.create( "x", DataTypes.Number ),
      TypeMember.create( "y", DataTypes.Number ),
      TypeMember.create( "z", DataTypes.Number ),
      TypeMember.create( "w", DataTypes.Number )
    ] 
  );

}